<template>
	<div v-if="facilities && simulationTypes" class="simulation-management">
		<div class="sync-wrapper">
			<ja-button
				v-if="showImportApiKey"
				name="import-data-button"
				:show="true"
				class="menu-btn small"
				@click.native="openImportDataModal"
				>{{ $t('importApiKey') }}</ja-button
			>

			<ja-button
				v-if="showSync"
				name="sync-button"
				class="menu-btn small"
				@click.native="openSyncModal"
				>{{ $t('sync') }}
			</ja-button>
			<ja-button
				v-if="showInstaller"
				name="download-installer-button"
				class="menu-btn small"
				@click.native="downloadInstaller"
				>{{ $t('downloadInstaller') }}</ja-button
			>
		</div>
		<ja-add-button
			v-if="showAddNewSimulation"
			class="add-btn"
			@click.native="openAddSimulationModal"
			>{{ $t('newSimulation') }}</ja-add-button
		>
		<ja-add-simulation-modal
			v-if="showAddSimulationModal"
			:show="showAddSimulationModal"
			:facilities="getFilteredFacilities()"
			:simulation="selectedSimulation"
			:simulation-types="simulationTypes"
			@closeModal="closeModal"
		></ja-add-simulation-modal>
		<ja-export-data-modal
			v-if="showExportDataModal"
			:show="showExportDataModal"
			:facilities="getFacilitiesForExport()"
			@loadingStartForAdmin="onLoadingStartForAdmin"
			@loadingStopForAdmin="onLoadingStopForAdmin"
			@closeModal="closeExportImportModals"
		></ja-export-data-modal>
		<ja-import-data-modal
			v-if="showImportDataModal"
			:show="showImportDataModal"
			:facilities="getFacilitiesForImport()"
			@loadingStartForAdmin="onLoadingStartForAdmin"
			@loadingStopForAdmin="onLoadingStopForAdmin"
			@closeModal="closeExportImportModals"
		></ja-import-data-modal>
		<ja-installer-modal
			v-if="showInstallerModal"
			:show="showInstallerModal"
			:facilities="getFacilitiesForImport()"
			@loadingStartForAdmin="onLoadingStartForAdmin"
			@loadingStopForAdmin="onLoadingStopForAdmin"
			@closeModal="closeModal"
		></ja-installer-modal>
		<ja-sim-management-tab
			ref="simulationDashboard"
			:facilities="facilities"
			:simulation-types="[{ value: null, name: '' }, ...simulationTypes]"
			@loadingStartForAdmin="onLoadingStartForAdmin"
			@loadingStopForAdmin="onLoadingStopForAdmin"
			@openSimulation="onOpenSimulation"
		></ja-sim-management-tab>
		<ja-sync-modal
			v-if="showSyncModal"
			:show="showSyncModal"
			:facilities="getFacilitiesForImport()"
			@loadingStartForAdmin="onLoadingStartForAdmin"
			@loadingStopForAdmin="onLoadingStopForAdmin"
			@closeModal="closeModal"
		></ja-sync-modal>
	</div>
</template>
<script>
import AddButton from '@/components/AdminSection/elements/AddButton';
import gql from 'graphql-tag';
import AddSimulationModal from '@/components/AdminSection/modals/AddSimulationModal';
import ExportDataModal from '@/components/AdminSection/modals/ExportDataModal';
import ImportDataModal from '@/components/AdminSection/modals/ImportDataModal';
import InstallerModal from '@/components/AdminSection/modals/InstallerModal';
import SyncModal from '@/components/AdminSection/modals/SyncModal';
import SimManagementTab from '../elements/SimManagementTab';
import FacilitiesService from '@/services/FacilitiesService';
import UserData from '@/mixins/UserData';
import Button from '@/components/ui/Button';
import { isCloudEnvironment } from '@/helpers/environment/useEnvConfig';

export default {
	components: {
		jaButton: Button,
		jaAddButton: AddButton,
		jaAddSimulationModal: AddSimulationModal,
		jaExportDataModal: ExportDataModal,
		jaImportDataModal: ImportDataModal,
		jaInstallerModal: InstallerModal,
		jaSimManagementTab: SimManagementTab,
		jaSyncModal: SyncModal
	},
	mixins: [UserData],
	data() {
		return {
			showModal: false,
			selectedSimulation: null,
			facilities: null,
			simulationTypes: null,
			showAddSimulationModal: false,
			showExportDataModal: false,
			showImportDataModal: false,
			showInstallerModal: false,
			showSyncModal: false,
			facility: null,
			simulationType: null,
			educatorID: '5',
			volunteerID: '6',
			JA_LOCALIZATION_IRL: this.$store.getters.isIrl,
			JA_SYNC_ENABLE: this.$store.getters.syncEnable
		};
	},
	computed: {
		isEducator() {
			return this.userData.roleId == this.educatorID;
		},
		isVolunteer() {
			return this.userData.roleId == this.volunteerID;
		},
		constants() {
			return this.$store.getters.constants;
		},
		hasApiKey() {
			return this.$store.getters.hasApiKey;
		},
		showImportApiKey() {
			return (
				!isCloudEnvironment &&
				!this.isEducator &&
				!this.hasApiKey &&
				!this.JA_LOCALIZATION_IRL &&
				this.JA_SYNC_ENABLE
			);
		},
		showInstaller() {
			return (
				isCloudEnvironment &&
				!this.isEducator &&
				!this.JA_LOCALIZATION_IRL &&
				this.JA_SYNC_ENABLE
			);
		},
		showSync() {
			return (
				!isCloudEnvironment &&
				!this.isEducator &&
				this.hasApiKey &&
				!this.JA_LOCALIZATION_IRL &&
				this.JA_SYNC_ENABLE
			);
		},
		showAddNewSimulation() {
			return !this.isEducator && !this.isVolunteer && isCloudEnvironment;
		}
	},
	mounted() {
		if (!this.isEducator && !this.isVolunteer && !isCloudEnvironment) {
			this.$store.dispatch('getHasApiKey');
		}
		FacilitiesService.getAll().then(allFacilities => {
			const facilities = [];
			allFacilities.forEach(facility => {
				facilities.push({
					name: facility.name,
					value: facility.facility_ID
				});
			});

			if (!this.isEducator) {
				facilities.push({
					value: null,
					name: 'No Facility'
				});
			}
			this.facilities = facilities;
		});
	},
	methods: {
		getFilteredFacilities() {
			if (this.selectedSimulation && !this.selectedSimulation.facility_ID) {
				return this.facilities.filter(facility => {
					return facility.name.includes(this.selectedSimulation.areaID);
				});
			}
			return this.facilities;
		},
		getFacilitiesForExport() {
			let facilities;
			if (
				this.userData.roleId == this.constants.nationalAdminRoleId ||
				this.userData.roleId == this.constants.superAdminRoleId
			) {
				// no whole area option
				facilities = this.facilities.filter(f => f.value != null);
			} else {
				facilities = this.facilities.map(facility => {
					if (facility.value) {
						return facility;
					} else {
						return {
							value: null,
							name: this.$t('wholeArea')
						};
					}
				});
			}

			return facilities;
		},
		getFacilitiesForImport() {
			let facilities;

			facilities = this.facilities.filter(f => f.value != null);

			return facilities;
		},
		closeModal() {
			this.selectedSimulation = null;
			this.showAddSimulationModal = false;
			this.showInstallerModal = false;
			this.showSyncModal = false;
			this.onLoadingStartForAdmin();
			this.$refs.simulationDashboard.refetchSimulations();
		},
		closeExportImportModals() {
			this.showExportDataModal = false;
			this.showImportDataModal = false;
		},
		onLoadingStartForAdmin() {
			this.$emit('loadingStartForAdmin');
		},
		onLoadingStopForAdmin() {
			this.$emit('loadingStopForAdmin');
		},
		onOpenSimulation(simulation) {
			this.selectedSimulation = simulation;
			this.openAddSimulationModal();
		},
		openAddSimulationModal() {
			this.showAddSimulationModal = true;
		},
		openExportDataModal() {
			this.showExportDataModal = true;
		},
		openImportDataModal() {
			this.showImportDataModal = true;
		},
		downloadInstaller() {
			this.showInstallerModal = true;
		},
		openSyncModal() {
			this.showSyncModal = true;
		}
	},
	apollo: {
		simulationTypes: {
			query: gql`
				{
					enumData(enumType: "simulationType") {
						apiName
						userFriendlyName
						enumIntValue
					}
				}
			`,
			update: function(data) {
				const simulationTypes = [];

				if (data && data.enumData) {
					data.enumData.forEach(type => {
						simulationTypes.push({
							name: type.userFriendlyName,
							value: type.apiName,
							id: type.enumIntValue
						});
					});
				}

				return simulationTypes;
			},
			fetchPolicy: 'no-cache'
		}
	}
};
</script>
<style lang="scss" scoped>
.simulation-management {
	margin: 32px auto 84px auto;
	max-width: 1000px;

	.add-btn {
		float: right;
	}

	.sync-wrapper {
		text-align: right;
		margin-bottom: 24px;
		.menu-btn {
			margin-left: 10px;
		}

		.small {
			min-width: 100px;
			height: 44px;
			padding-left: 24px;
			padding-right: 24px;
		}
	}
}
</style>
